import React, { useEffect, useState } from 'react';
import BN from 'bignumber.js';
import { useSelector, useDispatch } from 'react-redux';
import cn from 'classnames';
import Button from '@material-ui/core/Button';
import { Input } from '../../../../../../../components/form';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-settings.module.scss';
import Header from '../../../../../../../components/Stake/header';
import PercentageButtons from '../../../../../../../components/Stake/percentage-buttons';
import { formatToken } from '../../../../../../../helpers/token-helper';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import * as rosnStakeActions from '../../../../../../../actions/rosn-stake-actions';
import RosnIcon from '../../../../../../../assets/images/rosn.svg';
import { toPowerOf } from '../../../../../../../blockchain/config';
import { ROSN } from '../../../../../../../constants/blockchain-constants';

const UnstakeSettings = () => {
  const dispatch = useDispatch();
  const colors = useGetTheme();

  const [amount, setAmount] = useState(`${toPowerOf}`);
  const [inputValue, setInputValue] = useState(amount);

  useEffect(() => {
    setInputValue(+new BN(amount).div(toPowerOf).toFixed(2, BN.ROUND_DOWN));
  }, [amount]);

  const { stakeBalance } = useSelector((state) => state.ROSNstake.stake);

  const handleAmountChange = (value) => {
    setAmount(value.amount);
  };

  return (
    <>
      <Header
        icon={RosnIcon}
        title={`${ROSN}-Unstaking`}
        onClickBack={() => dispatch(rosnStakeActions.stakeReset())}
      />
      <div className={stylesParent.cardContent} style={{ color: colors.text }}>
        <div className={styles.cardTopContainer}>
          <div className={stylesParent.cardTextRow}>
            <div className={stylesParent.cardTextRowLabel}>Current Total Stake:</div>
            <div className={stylesParent.cardTextRowValue}>
              {formatToken(stakeBalance)} {ROSN}
            </div>
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.bodyTitle}>Unstake Amount</div>
          <div className={styles.inputRow}>
            <span className={styles.inputRowLabel} style={{ color: colors.text }}>
              {ROSN}
            </span>
            <div className={styles.inputRowContainer}>
              <Input
                value={inputValue}
                onChange={(e) =>
                  handleAmountChange({
                    amount: new BN(e.target.value || '0').times(toPowerOf).toString(10),
                  })
                }
                type='number'
              />
              <div className={cn(styles.percentageContainer, styles.smallTopIndent)}>
                <PercentageButtons balance={stakeBalance} onClick={handleAmountChange} />
              </div>
            </div>
          </div>
          <div className={stylesParent.cardFooterControls}>
            <Button
              onClick={() => dispatch(rosnStakeActions.unstakeInformation({ amount }))}
              variant='contained'
              color='secondary'
              className={stylesParent.cardFooterControlsButton}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnstakeSettings;
